module.exports = __webpack_public_path__ + "media/images/new/public_land_map_overlays_laptop-3c1677413861d13538ac977e2a7dd22f.png";